import { IStoreState } from '../types';

export const getAccessRules = (state: IStoreState) => state.accessRules;
